export default {"src":"https://images-cdn.curipod.com/d-f267caa1/_next/static/media/bground.4c7c3901.svg","height":1908,"width":2989};